// extracted by mini-css-extract-plugin
module.exports = {"reveal":"research-motion_reveal__n8MFm","in":"research-motion_in__obTjN","stagger":"research-motion_stagger__ajGKd"};